/**
 * Limiares do agro. O selo de geada e a janela de pulverização são calculados no
 * motor do WIREDESK com estes números; o site só mostra o resultado.
 */
import type { ErroDeCampo, LimiaresAgro } from '@/types/portal';

import { CampoNumero } from './campos';
import { erroDe } from './helpers';
import styles from './Portal.module.css';

interface Props {
  limiares: LimiaresAgro;
  onChange: (l: LimiaresAgro) => void;
  erros: ErroDeCampo[];
  campo: string;
}

export function EditorLimiares({ limiares, onChange, erros, campo }: Props) {
  const g = limiares.geada;
  const p = limiares.pulverizacao;
  const geada = (parcial: Partial<LimiaresAgro['geada']>) =>
    onChange({ ...limiares, geada: { ...g, ...parcial } });
  const pulv = (parcial: Partial<LimiaresAgro['pulverizacao']>) =>
    onChange({ ...limiares, pulverizacao: { ...p, ...parcial } });

  return (
    <div style={{ display: 'grid', gap: 'var(--sp-4)' }}>
      <div>
        <h4 className={styles.sub2}>Geada (temperatura mínima prevista a 2 m)</h4>
        <div className={styles.grade}>
          <CampoNumero
            rotulo="Risco de geada até (°C)"
            valor={g.risco_ate_c}
            min={-10}
            max={10}
            passo={0.5}
            dica="Mínima igual ou abaixo disto: risco de geada."
            erro={erroDe(erros, `${campo}.geada.risco_ate_c`)}
            onChange={(v) => geada({ risco_ate_c: v })}
          />
          <CampoNumero
            rotulo="Risco alto até (°C)"
            valor={g.alto_ate_c}
            min={-10}
            max={10}
            passo={0.5}
            dica="Igual ou abaixo disto: risco alto. Não passa do valor ao lado."
            erro={erroDe(erros, `${campo}.geada.alto_ate_c`)}
            onChange={(v) => geada({ alto_ate_c: v })}
          />
        </div>
      </div>
      <div>
        <h4 className={styles.sub2}>Pulverização (hora favorável)</h4>
        <div className={styles.grade}>
          <CampoNumero
            rotulo="Vento máximo (km/h)"
            valor={p.vento_max_kmh}
            min={0}
            max={60}
            passo={0.5}
            erro={erroDe(erros, `${campo}.pulverizacao.vento_max_kmh`)}
            onChange={(v) => pulv({ vento_max_kmh: v })}
          />
          <CampoNumero
            rotulo="Umidade mínima (%)"
            valor={p.umidade_min_pct}
            min={0}
            max={100}
            erro={erroDe(erros, `${campo}.pulverizacao.umidade_min_pct`)}
            onChange={(v) => pulv({ umidade_min_pct: v })}
          />
          <CampoNumero
            rotulo="Temperatura máxima (°C)"
            valor={p.temp_max_c}
            min={0}
            max={50}
            passo={0.5}
            erro={erroDe(erros, `${campo}.pulverizacao.temp_max_c`)}
            onChange={(v) => pulv({ temp_max_c: v })}
          />
          <CampoNumero
            rotulo="Chuva máxima (mm)"
            valor={p.chuva_max_mm}
            min={0}
            max={20}
            passo={0.5}
            erro={erroDe(erros, `${campo}.pulverizacao.chuva_max_mm`)}
            onChange={(v) => pulv({ chuva_max_mm: v })}
          />
        </div>
      </div>
    </div>
  );
}
